import i18next from "i18next";
import React from "react";
import { Flex } from "antd";

import RedesignButton from "~/shared/ui/Fields/RedesignButton";
import {
  APPEAL_STATUS,
  IAppealPeriodShema,
  IAppealSchema,
  RESOLUTION_STATUS,
} from "~/entity/Appeals/model/schema";
import { isDateInPeriod } from "~/pages/Appeal/ui/TableCellComponents/AppealStatusFrontendController/model/adapter";
import { usePermissions } from "~/shared/context/PermissionContext";

import s from "./AppealStatusFrontendController.less";

interface IAppealStatusFrontendControllerProps {
  value: IAppealSchema[keyof IAppealSchema];
  malusStatus: IAppealSchema["malusStatusFrontend"];
  resolutionStatus: IAppealSchema["resolutionStatusFrontend"];
  onOpenFilesModal: (files: IAppealSchema["files"]) => void;
  onOpenAddAppealModal: () => void;
  files: IAppealSchema["files"];
  periodsData: IAppealPeriodShema[];
}

export const AppealStatusFrontendController = (
  props: IAppealStatusFrontendControllerProps,
) => {
  const {
    value,
    malusStatus,
    resolutionStatus,
    files,
    onOpenAddAppealModal,
    onOpenFilesModal,
    periodsData,
  } = props;

  const { hasPermission } = usePermissions();

  const appealIsResolved =
    resolutionStatus === RESOLUTION_STATUS.rejected ||
    resolutionStatus === RESOLUTION_STATUS.accepted;

  const statusKey = value as IAppealSchema["appealStatusFrontend"] | "-";
  const statusText = !appealIsResolved
    ? i18next.t(`appeal.appealStatus.${statusKey}`, {
        defaultValue: statusKey,
      })
    : statusKey &&
      i18next.t(`appeal.appealStatus.fullResolved`, {
        defaultValue: statusKey,
      });

  const isInfoRequested = statusKey === APPEAL_STATUS.needInfo;
  const showText =
    statusKey === APPEAL_STATUS.notRequired && String(malusStatus) === "false";
  const showSubmitButton =
    (statusKey === APPEAL_STATUS.draft ||
      statusKey === APPEAL_STATUS.initial ||
      statusKey === APPEAL_STATUS.needInfo) &&
    String(malusStatus) !== "false";
  const showLink =
    !showSubmitButton &&
    (statusKey === APPEAL_STATUS.draft ||
      statusKey === APPEAL_STATUS.needInfo ||
      statusKey === APPEAL_STATUS.sent ||
      resolutionStatus === RESOLUTION_STATUS.review ||
      resolutionStatus === RESOLUTION_STATUS.rejected ||
      resolutionStatus === RESOLUTION_STATUS.accepted);

  const isPeriodActive = isDateInPeriod(new Date(), periodsData);
  const isSubmitDisabled = !isPeriodActive;

  return (
    <div className={s.container}>
      {!showText && (
        <>
          {showSubmitButton ? (
            <Flex gap={4} vertical>
              {statusKey !== APPEAL_STATUS.initial && <span>{statusText}</span>}
              {statusKey === APPEAL_STATUS.initial && isSubmitDisabled && "-"}
              {!isSubmitDisabled &&
                hasPermission("employeeAccounting.appeal.send") && (
                  <RedesignButton
                    theme="main"
                    txtBtn={i18next.t("appeal.submitAppeal", {
                      defaultValue: "Подать апелляцию",
                    })}
                    onClick={onOpenAddAppealModal}
                    customClassName={s.submitButton}
                    disabled={isSubmitDisabled}
                  />
                )}
            </Flex>
          ) : (
            <div className={s.statusWrapper}>
              <span>{statusText}</span>
            </div>
          )}
          {showLink && (
            <button
              type="button"
              onClick={() => onOpenFilesModal(files || [])}
              className={s.linkButton}
            >
              {i18next.t("appeal.link", { defaultValue: "Подробнее" })}
            </button>
          )}
        </>
      )}
      {showText && <span>{statusText}</span>}
    </div>
  );
};
